import React from 'react'
import {Sahel, kasba, alhor, Dawajin} from '../Assets/types'

const TypesFood = () => {
    const types = [
        Sahel, kasba, alhor, Dawajin
    ]

    // Create multiple copies for seamless scrolling
    const repeatedTypes = [...types, ...types, ...types, ...types, ...types, ...types]

    return (
        <div className='w-full bg-[#F4F4F4] md:py-10 py-7 relative overflow-hidden'>
            <div className='absolute left-0 top-0 bottom-0 w-[100px] bg-gradient-to-r from-[#F4F4F4]  to-transparent z-[100]'></div>
            <div className='absolute right-0 top-0 bottom-0 w-[100px] bg-gradient-to-l from-[#F4F4F4] to-transparent z-[100]'></div>
            <div className='relative flex gap-16 lg:gap-28 overflow-hidden'>
                <div className='flex gap-16 lg:gap-28 animate-infinite-scroll-smooth'>
                    {/* First set of images */}
                    {repeatedTypes.map((type, index) => (
                        <div 
                            key={`first-${index}`} 
                            className='type w-[100px] h-[100px] lg:w-[110px] lg:h-[110px] flex justify-center items-center '
                        >
                            <img 
                                src={type} 
                                alt="type" 
                                className='w-full h-full object-contain'
                            />
                        </div>
                    ))}
                    {/* Duplicate set for seamless loop */}
                    {repeatedTypes.map((type, index) => (
                        <div 
                            key={`second-${index}`} 
                            className='type w-[100px] h-[100px] lg:w-[110px] lg:h-[110px] flex justify-center items-center'
                        >
                            <img 
                                src={type} 
                                alt="type" 
                                className='w-full h-full object-contain'
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default TypesFood